export default __webpack_public_path__ + "static/media/referrals.b93abe79.svg";